/** The methods listed below are global methods available
 *  under Vue.$helpers.methodName(), e.g. this.$helpers.isEmptyObject()
 */

import {
  store
} from "@/store/store";
import airlines from "@/modules/airlineCodes.js";

export default {
  miltTimeConvert(hours) {
    if (hours === 24) {
      return "11:59 P.M.";
    }
    let timeValue;
    if (hours > 0 && hours <= 12) {
      timeValue = "" + hours;
    } else if (hours > 12) {
      timeValue = "" + (hours - 12);
    } else if (hours === 0) {
      timeValue = "12";
    }
    timeValue += ":00";
    timeValue += hours >= 12 && hours < 24 ? " P.M." : " A.M.";
    return timeValue;
  },
  isEmptyObject(obj) {
    return JSON.stringify(obj) === "{}";
  },
  //not sure if this is better than the above
  //isEmptyObject(obj) {
  //  return Object.keys(obj).length == 0;
  //},
  hashCode(str) {
    let hash = 0,
      i,
      chr;
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },
  encryptText(str) {

    return Buffer.from(str, 'utf8').toString('base64'); //replaces btoa(text);
  },
  decryptText(str) {
    return Buffer.from(str, 'base64').toString('utf8'); // replaces atob(text);
  },
  randomString(length){
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  },
  scrollToTop() {
    window.scrollTo(0, 0);
  },
  /*
  logoCall1(airline, width, height) {
    // AirHex
    return (
      this.$appConfig.airHexEndPoint +
      airline +
      "_" +
      width +
      "_" +
      height +
      "_s.png?md5apikey=" +
      md5(airline + "_" + width + "_" + height + this.$appConfig.airHexToken)
    );
  },
  */
  airlineLogo(airline, width, height) {
    // Imgix + AWS Hosted - Example: https://tripcircuit.imgix.net/airlines/logos/800x800/AA.png?w=40
    if (airline !== "Multiple") {
      return (
        "https://tripcircuit.imgix.net/airlines/logos/800x800/" +
        airline +
        ".png?w=" +
        width +
        "&h=" +
        height
      );
    } else {
      return "";
    }
  },
  airlineName(airlineCode = "") {
    let airlines = store.state.bookTravel.vendors.airlines;
    let match = airlines[airlineCode];
    if (!match) {
      return airlineCode;
    }
    return match;
  },
  getAirlineName(airlineCode) {
    //let airlines = this.airlines;
    let airline = airlines.find(({
      code
    }) => code == airlineCode);

    if (!airline) return null;

    return airline.name;
  },
  stopsLabels(numberOfStops) {

    if (numberOfStops == 0) {
      return "Nonstop";
    }
    if (numberOfStops == 1) {
      return numberOfStops + " stop or less";
    }
    return numberOfStops + " stops or less";
  },
  getAirportLocation(airportCode) {
    let airports = store.state.bookTravel.airports;
    let airport = airports.find(airportItem => airportItem.code === airportCode);

    if (!airport) return null;

    return airport.city + ", " + airport.state;
  },
  doubleZero(val) {
    if (val === "0" || val === 0) {
      val = "00";
    }
    return val;
  },
  capitalize(name = "default") {
    name = name.toLowerCase();
    let words = name.split(" ");
    return words
      .map((word) => {
        return word[0].toUpperCase() + word.substring(1);
      })
      .join(" ");
  },
  validateProp(val) {
    if (!val || val === "") {
      this.error = true;
    }
  },
  percentageOfTotalFlights(value, total) {
    return Math.round((value * 100) / total) + "%";
  },
  /**
   *
   * @param {*} fn
   * @param {*} defaultVal
   * @returns
   *
   * safely access deeply nested object properties
   * use it like this:
   * getSafe(() => obj.a.lot.of.properties);
   * or add an optional default value
   * getSafe(() => obj.a.lot.of.properties, 'nothing');
   */
  getSafe(fn, defaultVal = null) {
    try {
      return fn();
    } catch (e) {
      return defaultVal;
    }
  },
  /*
  minimize() {
    this.maximized = !this.maximized;
  },
  */
  findAirportByCode(code) {
    let foundAirport = [];

    if (code && code.length > 2) {
      // console.log('find', code, typeof code);
      code = code.toUpperCase();
      let airports = store.state.bookTravel.airports;
      let searchedAirport = airports.filter(airport => airport.code.toUpperCase() === code);

      // console.log('found', searchedAirport);
      foundAirport = searchedAirport[0];
    }

    return foundAirport;
  },

  //Get Travel Policy builder labels
  getComparisionLabel(operator) {

    var operatorLabel;

    switch (operator) {
      case "less_than":
        operatorLabel = "less than";
        break;
      case "greater_than":
        operatorLabel = "greater than";
        break;
      case "equal":
        operatorLabel = "equal to";
        break;
      case "not_equal":
        operatorLabel = "not equal to";
        break;
      case "less_than_inclusive":
        operatorLabel = "less than or equal";
        break;
      case "greater_than_inclusive":
        operatorLabel = "greater than or equal";
        break;
      case "in":
        operatorLabel = "in list";
        break;
      case "not_in":
        operatorLabel = "not in list";
        break;

      case "true":
        operatorLabel = "is true";
        break;
      case "false":
        operatorLabel = "is false";
        break;
      default:
        operatorLabel = "";
    }
    return operatorLabel;


  },

  getAirClassLabel(key) {

    var label = '';
    switch (key) {
      case "Y":
        label = "Economy";
        break;
      case "M":
        label = "Standard Economy";
        break;
      case "W":
        label = "Premium Economy";
        break;
      case "C":
        label = "Business";
        break;
      case "F":
        label = "First";
        break;



      default:
        label = 'N/A'
    }
    return label;
  },

  getTravelPolicyViolationVisibilityLabel(key) {

    var label = '';
    switch (key) {
      case "show":
        label = "Show the result and allow it be booked";
        break;
      case "hide":
        label = "Hide the result";
        break;
      case "unselectable":
        label = "Show the result but don't allow it be booked";
        break;
    



      default:
        label = 'N/A'
    }
    return label;
  },
  getTravelPolicyViolationAction(key) {

    var label = '';
    switch (key) {
      case "hard":
        label = "An approver must approve the trip";
        break;
      case "soft":
        label = "An approver can review  the trip";
        break;
      case "none":
        label = "No approval process";
        break;
    



      default:
        label = 'N/A'
    }
    return label;
  },
  buildTravelPolicyRuleMessage(rule){
      if (rule.conditions.length > 0) {
        if (rule.conditions.length == 1) {
          return rule.conditions[0].message;
        } else {
          var triggerWhen = rule.triggerWhen == "any" ? "OR" : "AND";

          let conditionMessages = rule.conditions.map((r) => r.message);

          return conditionMessages.join(
            ' &nbsp;<span class="has-text-success has-text-weight-bold">' +
              triggerWhen +
              "</span>&nbsp;"
          );
        }
      }
      return null;
  }


};